export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8941.9d1916e8.jpg";